import { blockConnectorFactory } from './asgard-bff/components/block_connector'
import { categoryTypeFactory } from './asgard-bff/components/category_type'
import { connectorCandidateFactory } from './asgard-bff/components/connector_candidate'
import { customFieldValueFactory } from './asgard-bff/components/custom_field_value'
import { keyDate } from './asgard-bff/components/key_date'
import { blockByIdFactory } from './asgard-bff/components/normalized_block'
import {
  categoryByIdFactory,
  categoryHierarchyFactory,
} from './asgard-bff/components/normalized_category'
import { chartByIdFactory } from './asgard-bff/components/normalized_chart'
import { blockConnectorCandidatesFactory } from './asgard-bff/responses/block_connector_candidates'
import { blockDetailFactory } from './asgard-bff/responses/block_details'
import {
  blocksFactory,
  singleCollectionBlockFactory,
} from './asgard-bff/responses/blocks'
import { parentBlockFactory } from './asgard-bff/responses/parent_block'
import { planFactory } from './asgard-bff/responses/plan'
import { workflowContextResourceFactory as v2WorkflowContextResourceFactory } from './v2/resource_objects/workflow_context'
import { readMomentWorkflowsFactory } from './v2/responses/read_moment_workflows'
import { blockDuplicationFactory } from './v3/components/block_duplication'
import { blockResourceFactory } from './v3/resource_objects/block'
import { blockCustomFieldValueResourceFactory } from './v3/resource_objects/block_custom_field_value'
import { boardResourceFactory } from './v3/resource_objects/board'
import { boardObjectResourceFactory } from './v3/resource_objects/board_object'
import { boardStandardColumnResourceFactory } from './v3/resource_objects/board_standard_column'
import { boardUserSettingResourceFactory } from './v3/resource_objects/board_user_setting'
import { categoryResourceFactory } from './v3/resource_objects/category'
import { categoryTypeResourceFactory } from './v3/resource_objects/category_type'
import { momentCustomFieldFactory } from './v3/resource_objects/moment_custom_field'
import { momentScheduleResourceFactory } from './v3/resource_objects/moment_schedule'
import { richTextDocumentResourceFactory } from './v3/resource_objects/rich_text_document'
import { userResourceFactory } from './v3/resource_objects/user'
import { userGroupResourceFactory } from './v3/resource_objects/user_group'
import { userProfileResourceFactory } from './v3/resource_objects/user_profile'
import { viewResourceFactory } from './v3/resource_objects/view'
import { viewColumnResourceFactory } from './v3/resource_objects/view_column'
import { viewStandardColumnResourceFactory } from './v3/resource_objects/view_standard_column'
import { workflowResourceFactory } from './v3/resource_objects/workflow'
import { workflowAssignmentResourceFactory } from './v3/resource_objects/workflow_assignment'
import { workflowContextResourceFactory } from './v3/resource_objects/workflow_context'
import { workflowResponseResourceFactory } from './v3/resource_objects/workflow_response'
import { workflowStageResourceFactory } from './v3/resource_objects/workflow_stage'
import { workspaceResourceFactory } from './v3/resource_objects/workspace'
import { readEntityWorkflowsFactory } from './v3/responses/read_entity_workflows'
import { readWorkflowFactory } from './v3/responses/read_workflow'
import { workflowStageFactory } from './v3/responses/workflow_stage'
import { workflowsFactory } from './v3/responses/workflows'

export const factories = {
  v2: {
    resourceObjects: {
      workflowContext: v2WorkflowContextResourceFactory,
    },
    responses: {
      readMomentWorkflows: readMomentWorkflowsFactory,
    },
  },
  v3: {
    components: {
      blockDuplication: blockDuplicationFactory,
    },
    resourceObjects: {
      block: blockResourceFactory,
      blockCustomFieldValue: blockCustomFieldValueResourceFactory,
      board: boardResourceFactory,
      boardObject: boardObjectResourceFactory,
      boardStandardColumn: boardStandardColumnResourceFactory,
      boardUserSetting: boardUserSettingResourceFactory,
      category: categoryResourceFactory,
      categoryType: categoryTypeResourceFactory,
      momentCustomField: momentCustomFieldFactory,
      momentSchedule: momentScheduleResourceFactory,
      viewColumn: viewColumnResourceFactory,
      viewStandardColumn: viewStandardColumnResourceFactory,
      richTextDocument: richTextDocumentResourceFactory,
      user: userResourceFactory,
      userGroup: userGroupResourceFactory,
      userProfile: userProfileResourceFactory,
      view: viewResourceFactory,
      workflow: workflowResourceFactory,
      workflowAssignment: workflowAssignmentResourceFactory,
      workflowContext: workflowContextResourceFactory,
      workflowResponse: workflowResponseResourceFactory,
      workflowStage: workflowStageResourceFactory,
      workspace: workspaceResourceFactory,
    },
    responses: {
      readEntityWorkflows: readEntityWorkflowsFactory,
      readWorkflow: readWorkflowFactory,
      workflowStage: workflowStageFactory,
      workflows: workflowsFactory,
    },
  },
  asgardBff: {
    responses: {
      blockDetail: blockDetailFactory,
      blocks: blocksFactory,
      parentBlock: parentBlockFactory,
      plan: planFactory,
      blockConnectorCandidates: blockConnectorCandidatesFactory,
    },
    components: {
      blockConnector: blockConnectorFactory,
      categoryType: categoryTypeFactory,
      connectorCandidate: connectorCandidateFactory,
      customFieldValue: customFieldValueFactory,
      keyDate,
      planHierarchy: categoryHierarchyFactory,
      noramlizedBlock: blockByIdFactory,
      normalizedCategory: categoryByIdFactory,
      normalizedChart: chartByIdFactory,
      singleCollectionBlock: singleCollectionBlockFactory,
    },
  },
}
